<script>

import AmsuScholarshipCard from "../AmsuScholarshipCard.vue";
import {mapActions, mapGetters, mapState} from "vuex";
import ScholarshipMeetingApi from "../../Services/Api/MeetingApi/ScholarshipMeetingApi";

import MeetingScholarshipStatementsTable from "../../Tables/Meeting/MeetingScholarshipStatementsTable.vue";

export default {
  name: "TheMeetingScholarshipStatementsCard",

  props: {
    loading: {
      type: Boolean,
      default: false,
    }
  },


  data() {
    return {
      tab: null,

      loadingZip: false,
    };
  },

  components: {
    MeetingScholarshipStatementsTable,
    AmsuScholarshipCard,
  },

  computed: {
    ...mapState({
      statements: state => state.scholarship_competition.statements,
      meeting: state => state.scholarship_meeting.meeting,
    }),

    ...mapGetters({
      completeStatements: 'scholarship_meeting/completeStatements',
      isEmptyMeeting: 'scholarship_meeting/isEmptyMeeting',
    }),

    isMoreNumberVerifiedCompletedStatements() {
      return this.completeStatements.length > this.meeting.number_seats_available;
    }

  },

  methods: {
    ...mapActions({
      openDialog: 'scholarship_vote/openDialog',
      getStatement: "scholarship_competition/getStatement",
    }),

    async downloadZipFile() {
      this.loadingZip = true;
      const response = await ScholarshipMeetingApi.backupFilesCompetitionsForMeeting(this.meeting.id);

      const href = window.URL.createObjectURL(response.data);

      const anchorElement = document.createElement('a');

      anchorElement.href = href;
      anchorElement.download = "Достижения участников ПГАС.zip";

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);

      this.loadingZip = false;
    },
  },

}
</script>

<template>
  <amsu-scholarship-card
    :loading="loading"
    class="py-3"
  >
    <v-card-title class="pb-0">
      Список заявлений студентов
      <v-btn
        icon
        :disabled="!meeting.access_current_meeting"
        @click="downloadZipFile"
        :loading="loadingZip"
      >
        <v-icon>fa-download</v-icon>
      </v-btn>
      <v-spacer/>
      <v-btn
        elevation="0"
        class="rounded-xl white--text"
        color="teal darken-3"
        @click="openDialog"
        :disabled="!meeting.access_current_meeting"
      >
        Голосование за участников
      </v-btn>
    </v-card-title>
    <v-card-title  class="pb-0 pt-1 pl-0">
      <v-tabs
        class="mb-0 pb-0"
        color="teal darken-3"
        v-model="tab"
      >
        <v-tab key="all-achievement">
          Все
        </v-tab>
        <v-tab key="complete-achievement">
          <v-badge
            color="teak darken-3"
          >
            <v-icon small v-show="isMoreNumberVerifiedCompletedStatements">fa-exclamation-triangle</v-icon> Подтвержденные
          </v-badge>
        </v-tab>
      </v-tabs>
    </v-card-title>

    <v-divider/>

    <v-tabs-items v-model="tab">
      <v-tab-item
        key="all-achievement"
      >
        <meeting-scholarship-statements-table
          :items="statements"
        />
      </v-tab-item>
      <v-tab-item
        key="complete-achievement"
      >
        <meeting-scholarship-statements-table
          :items="completeStatements"
        />
      </v-tab-item>
    </v-tabs-items>

    <v-overlay
      :opacity="0.8"
      :absolute="true"
      :value="isEmptyMeeting"
    >
      <div class="text-h6">Параметры заседания не заполнены</div>
      <div>
        - Введите Председателя
      </div>
      <div>
        - Введите Секретаря
      </div>
      <div>
        - Введите Слушателей
      </div>
    </v-overlay>

  </amsu-scholarship-card>
</template>

<style scoped>

</style>